export { PixelIcon } from './PixelIcon';
export { SvgIcon } from './SvgIcon';

export type { IconNameType } from './PixelIcon';
export type { IconSize } from './SvgIcon.styles';
